

































import { Component, Vue,Inject, Prop,Watch } from 'vue-property-decorator';
import Util from '../../../lib/util'
import AbpBase from '../../../lib/abpbase'
import {FieldType,Filter,CompareType} from '../../../store/entities/filter'
import PageRequest from '../../../store/entities/page-request'
import CreateRole from './create-role.vue'
import EditRole from './edit-role.vue'
@Component({
    name:'role',
    components:{CreateRole,EditRole}
})
export default class Roles extends AbpBase{
    edit(){
        this.editModalShow=true;
        (this as any).$refs.editRole.GetPermissions();
    }
    filters:Filter[]=[
        {Type:FieldType.String,Value:'',FieldName:'Name',CompareType:CompareType.Contains},
        {Type:FieldType.String,Value:'',FieldName:'DisplayName',CompareType:CompareType.Contains},
        {Type:FieldType.DataRange,Value:'',FieldName:'Description',CompareType:CompareType.Contains}
    ]
    searchData:any = {}
    createModalShow:boolean=false;
    editModalShow:boolean=false;
    get list(){
        return this.$store.state.role.list;
    };
    get loading(){
        return this.$store.state.role.loading;
    }
    create(){
        this.createModalShow=true;
    }
    pageChange(page:number){
        this.searchData.SkipCount = page-1;
        this.getpage();
    }
    pagesizeChange(pagesize:number){
        //this.$store.commit('role/setPageSize',pagesize);
        this.searchData.MaxResultCount = pagesize;
        this.getpage();
    }
    search(){
        // this.searchData.SkipCount = 0;
        this.getpage();
    }
    async getpage(){
        // let where= Util.buildFilters(this.filters);
        // let pagerequest=new PageRequest();
        // pagerequest.maxResultCount=this.pageSize;
        // pagerequest.skipCount=(this.currentPage-1)*this.pageSize;
        // pagerequest.where=where;
        await this.$store.dispatch({
            type:'role/getAll',
            data: this.searchData
        })
    }
    get pageSize(){
        return this.$store.state.role.pageSize;
    }
    get totalCount(){
        return this.$store.state.role.totalCount;
    }
    get currentPage(){
        return this.$store.state.role.currentPage;
    }
    columns=[{
        title: '角色名称',
        key:'name'
    },{
        title: '显示名称',
        key:'displayName'
    },{
        title: '是否固定',
        render:(h:any,params:any)=>{
            return h('span',params.row.isStatic?'是':'否')
        }
    },{
        title: '操作',
        key:'Actions',
        width:150,
        render:(h:any,params:any)=>{
            return h('div',[
                h('Button',{
                    props:{
                        type:'primary',
                        size:'small'
                    },
                    style:{
                        marginRight:'5px'
                    },
                    on:{
                        click:()=>{
                            this.$store.commit('role/edit',params.row);
                            this.edit();
                        }
                    }
                }, '编辑'),
                h('Button',{
                    props:{
                        type:'error',
                        size:'small'
                    },
                    on:{
                        click:async ()=>{
                            this.$Modal.confirm({
                                    title: '提示',
                                    content: '确定删除此角色？',
                                    okText: '确定',
                                    cancelText: '取消',
                                    onOk:async()=>{
                                        await this.$store.dispatch({
                                            type:'role/delete',
                                            data:params.row
                                        })
                                        await this.getpage();
                                    }
                            })
                        }
                    }
                }, '删除')
            ])
        }
    }]
    async created(){
        this.getpage();
        await this.$store.dispatch({
            type:'role/getAllPermissions'
        })
    }
}
